var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    color: "#8EA4A6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.6668 39.7304C8.68553 37.7062 7.19094 35.2576 6.29618 32.5702C5.40143 29.8828 5.12997 27.027 5.50239 24.2192C5.8748 21.4113 6.88131 18.7251 8.44568 16.3638C10.01 14.0026 12.0912 12.0283 14.5316 10.5905C16.972 9.15276 19.7076 8.2892 22.5312 8.06527C25.3548 7.84133 28.1923 8.2629 30.8288 9.29802C33.4653 10.3331 35.8317 11.9547 37.7487 14.0398C39.6657 16.125 41.0831 18.619 41.8934 21.3331H46.6668C49.2415 21.3328 51.748 22.1606 53.8161 23.6942C55.8842 25.2279 57.4041 27.386 58.1515 29.8499C58.8988 32.3137 58.8339 34.9526 57.9663 37.3767C57.0987 39.8008 55.4744 41.8816 53.3334 43.3117",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32 32V56",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M42.6666 42.6667L31.9999 32L21.3333 42.6667",
    stroke: "currentColor",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.47f0ecedbd5df304d7df1cadeff902a3.svg";
export { ForwardRef as ReactComponent };